export default "__VITE_ASSET__BLr_Uett__"